<template>
  <div class="nested-select d-block" v-on-clickaway="closeSelect">
    <label @click="closeSelect">{{ label }}</label>
    <div
      @click="openListOnClick"
      class="input-like"
      tabindex="0"
      @focus="openListOnFocus">
      <span v-if="value === ''">Select</span>
      <span v-else class="cut-text">{{ $t(cmpTextValue) }}</span>
      <Icon
        class="icon arrow-icon"
        name="arrowDown"
        size="28" />
    </div>
    <div v-show="isListOpened" class="options-list">
      <div class="menu-holder"
        :style="{
        transform: `translateX(${currentLevel}%)`,
        height: boxHeight,
        }">
      <!-- PANELS -->
        <!-- 1st level -->
        <div ref="firstLevelPanel"
          class="first-level options-panel" :style="{height: boxHeight}">
          <div>
            <h2>{{ $t('packaging') }}</h2>
            <ul>
              <li
                @keydown.prevent="nextItemFirstLevel"
                tabIndex="-1"
                ref="opt-1"
                @click="openSecondLevel('custom')"><!-- @click="parcelTypeSelected('custom')" -->
                <Icon
                  :circle="true"
                  class="icon"
                  name="edit"
                  size="15" />
                <span>{{ $t('select_type') }}</span>
              </li>
              <li
                @keydown.prevent="nextItemFirstLevel"
                tabIndex="-1"
                ref="opt-2"
                @click="openSecondLevel('carrier')">
                <Icon
                  :circle="true"
                  class="icon"
                  name="truck"
                  size="15" />
                <span>{{ $t('Carrier provided packaging') }}</span>
              </li>
              <li
                @keydown.prevent="nextItemFirstLevel"
                tabIndex="-1"
                ref="opt-3"
                @click="openSecondLevel('own')">
                <Icon
                  :circle="true"
                  class="icon"
                  name="single"
                  size="15" />
                <span>{{ $t('Own added packaging') }}</span>
              </li>
            </ul>
          </div>
          <div class="separator medium" v-if="mostUsedDummy.length > 0" />
          <div v-if="mostUsedDummy.length > 0">
            <h2>Most Used</h2>
            <ul v-if="mostUsedDummy.length > 0">
              <li @keydown.prevent="searchIt" v-for="(item, index) in mostUsedDummy" :key="`most-${index}`">
                <LogosSVG
                  v-if="item.type == null"
                  :name="item.name"
                  size="35"
                  class="m-r-20 icon circled-icon" />
                <Icon
                  v-else
                  :circle="true"
                  class="icon"
                  :name="packagingItemName(item.type)"
                  size="15" />
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 2nd level -->
        <div ref="carrier"
          class="options-panel second-level"
          :style="{height: boxHeight}"
          v-show="currentLevelName === 'carrier'">
            <h2 @click="openFirstLevel">
              <Icon
                :circle="true"
                class="icon"
                name="arrowLeft"
                size="20" />
              <span>{{ $t('Carrier provided packaging') }}</span>
            </h2>
            <div class="search-holder">
              <input
                @keydown="searchIt"
                ref="searchField1"
                class="search"
                v-model="search"
                :placeholder="$t('Search...')" />
            </div>
            <div v-for="(list, key, index) in filteredListCarrier" :key="`carrier-${key}`">
              <div class="separator medium" v-if="index != 0"></div>
              <h2>{{ key }}</h2>
              <ul>
                <li
                  v-for="(pack, indexx) in list"
                  :key="`carrier-packaging-${indexx}`"
                  tabIndex="-1"
                  :ref="`${index}-${indexx}`"
                  @keydown.prevent="nextItemSecondLevel(key, $event)"
                  @click="parcelTypeSelected(pack)">
                  <LogosSVG
                    :name="key.toString()"
                    size="35"
                    class="m-r-20 icon circled-icon" />
                  <span>{{ pack.name }}</span>
                </li>
              </ul>
            </div>
        </div>
        <div
          ref="own"
          class="options-panel second-level"
          :style="{height: boxHeight}"
          v-show="currentLevelName === 'own'">
            <h2 @click="openFirstLevel">
              <Icon
                :circle="true"
                class="icon"
                name="arrowLeft"
                size="20" />
                <span>{{ $t('Own added packaging') }}</span>
            </h2>
            <div class="search-holder">
              <input
                @keydown="searchItOwn"
                ref="searchField2"
                class="search"
                v-model="search"
                :placeholder="$t('Search...')" />
            </div>
            <ul>
              <li
                v-for="(item, index) in filteredListOwn" :key="`own-${index}`"
                @keydown.prevent="nextItemOwn"
                tabIndex="-1"
                :ref="`own-${index}-opt`"
                @click="parcelTypeSelected(item)">
                <Icon
                  :circle="true"
                  class="icon"
                  :name="packagingItemName(item.type)"
                  size="15" />
                <span>{{ item.name }}</span>
              </li>
            </ul>
        </div>
        <div
          ref="custom"
          class="options-panel second-level"
          :style="{height: boxHeight}"
          v-show="currentLevelName === 'custom'">
            <h2 @click="openFirstLevel">
              <Icon
                :circle="true"
                class="icon"
                name="arrowLeft"
                size="20" />
                <span>{{ $t('select_type') }}</span>
            </h2>
            <div class="search-holder">
              <input
                @keydown="searchItOwn"
                ref="searchField2"
                class="search"
                v-model="search"
                :placeholder="$t('Search...')" />
            </div>
            <ul>
              <li
                v-for="(item, index) in filteredListCustom" :key="`custom-${index}`"
                @keydown.prevent="nextItemOwn"
                tabIndex="-1"
                :ref="`custom-${index}-opt`"
                @click="parcelTypeSelected(item)">
                <Icon
                  :circle="true"
                  class="icon"
                  :name="packagingItemName(item.type)"
                  size="15" />
                <span>{{ $t(item.name) }}</span>
              </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import LogosSVG from "@/assets/images/logosSVG";

export default {
  name: 'NestedSelect',
  directives: {
    onClickaway: onClickaway,
  },
  components: {LogosSVG},
  props: {
    getter: {
      type: Object,
      default: function () {
        return {};
      },
    },
    mostUsedDummy: {
      type: Array,
      default: function () {
        return [];
      },
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    renderCustomText: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    showSearch: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      firstLevelIndexItem: 1,
      indexItem: 0,
      optionsList: this.options || [],
      isListOpened: false,
      openedOnClick: false,
      search: '',
      carrierSize: 0,
      carrierIndex: 0,
      indexItemOwn: 0,
      currentLevelName: 'firstLevelPanel',
      baseHeight: '',
      // Lists
      currentLevel: 0,
      mostUsedList: [],
      ownList: [],
      carrierList: [],
    };
  },
  computed: {
    boxHeight() {
      if(this.currentLevel === 0){
        // First level opened
        let mostUsedLength = this.mostUsedDummy.length;
        if( mostUsedLength == 1 ){
          return '398px';
        }
        if( mostUsedLength == 2 ){
          return '443px';
        }
        if( mostUsedLength == 3 ){
          return '488px';
        }
        return '263px';
      } else {
        // Second level opened
        return '400px';
      }
    },
    filteredListCarrier() {
      if(this.currentLevelName === 'carrier') {
        const returnedObj = {};
        for (let key in this.getter.carrier_packaging) {
          if (this.getter.carrier_packaging.hasOwnProperty(key)) this.carrierSize++;
          returnedObj[key] = this.getter.carrier_packaging[key].filter(option => {
            return option.name.toLowerCase().includes(this.search.toLowerCase());
          });
        }
        return returnedObj;
      }
    },
    filteredListOwn() {
      if(this.getter.our_packaging.length < 1) return [];
      return this.getter.our_packaging.filter(option => {
        return option.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredListCustom() {
      if(this.customPackagingList < 1) return [];
      return this.customPackagingList.filter(option => {
        return option.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.value === null) return this.$t('Custom dimensions');
      if( this.filterLists(this.customPackagingList).length > 0 ){
        return this.filterLists(this.customPackagingList)[0].name;
      }
      if( this.filterLists(this.getter.our_packaging).length > 0 ){
        return this.filterLists(this.getter.our_packaging)[0].name;
      }
      for (let key in this.getter.carrier_packaging) {
        if( this.filterLists(this.getter.carrier_packaging[key]).length > 0 ){
          return this.filterLists(this.getter.carrier_packaging[key])[0].name;
        }
      }
    },
    customPackagingList() {
      return [
        {name: this.$t('Custom dimensions'), id: null, type: 0},
        ...this.getter.custom_packaging
      ];
    },
  },
  created() {
    //On created hook (copy or draft shipment) we dont wanna emit parcelTypeSelected event, cause we need to preserve values from copied shipment

    //OLD, but it is needed to set default packaging, so we need to find another solution
    if(this.value === null){
      this.parcelTypeSelected({
        name: 'Custom dimensions',
        id: null,
      });
    } else {
      if( this.filterLists(this.getter.custom_packaging).length > 0 ){
        this.parcelTypeSelected(this.filterLists(this.getter.custom_packaging)[0]);
      }
      if( this.filterLists(this.getter.our_packaging).length > 0 ){
        this.parcelTypeSelected(this.filterLists(this.getter.our_packaging)[0]);
      }
      for (let key in this.getter.carrier_packaging) {
        if( this.filterLists(this.getter.carrier_packaging[key]).length > 0 ){
          this.parcelTypeSelected(this.filterLists(this.getter.carrier_packaging[key])[0]);
        }
      }
    }
  },
  methods: {
    packagingItemName(type) {
      if(parseInt(type) === 0) return 'edit';
      if(parseInt(type) === 1) return 'letter';
      if(parseInt(type) === 2) return 'softBag';
      if(parseInt(type) === 3) return 'savedItems';
      if(parseInt(type) === 4) return 'tube';
      if(parseInt(type) === 5) return 'arrowRight';
      if(parseInt(type) === 6) return 'arrowRight';
      if(parseInt(type) === 7) return 'arrowRight';
      if(parseInt(type) === 8) return 'arrowRight';
    },
    filterLists(list) {
      return list.filter(opt => opt.id == this.value);
    },
    parcelTypeSelected(type) {
      //Should not be executed on copy or draft shipment initially, only when user change packaging value
      let typeObj = {
        name: type.id, // null
        packagingName: type.name, //'Custom dimensions',// this.cmpTextValue,
        width: '',
        height: '',
        length: '',
        weight: '',
        weight_measure: 'kg',
        dimension_measure: 'cm'
      };

      if(type.name !== 'Custom dimensions'){
        typeObj = {
          name: type.id,
          packagingName: type.name,// this.cmpTextValue,
          width: type.width,
          height: type.height,
          length: type.length,
          weight: type.weight,
          weight_measure: type.weight_measure ? type.weight_measure : 'kg',
          dimension_measure: type.dimension_measure ? type.dimension_measure : 'cm'
        };
      }
      this.closeSelect();
      this.currentLevelName = 'firstLevelPanel';
      this.currentLevel = 0;
      this.search = '';
      this.$emit('parcelTypeSelected', typeObj);
    },
    startingBaseHeight() {
      this.baseHeight = this.$refs[`${this.currentLevelName}`].offsetHeight + 'px';
    },
    openList() {
      this.isListOpened = true;
      this.$nextTick(() => {
        this.startingBaseHeight();
        this.$refs['opt-1'].focus();
      });
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        this.startingBaseHeight();
        this.$refs['opt-1'].focus();
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.$nextTick(() => {
        this.startingBaseHeight();
        this.$refs['opt-1'].focus();
      });
    },
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.$refs[`0-0`][0].focus();
      } else {
        this.search = event.target.value;
      }
    },
    searchItOwn(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.$refs[`own-${this.indexItemOwn}-opt`][0].focus();
      } else {
        this.search = event.target.value;
      }
    },
    nextItemOwn (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItemOwn > 0) {
      	this.indexItemOwn--;
        this.$refs[`own-${this.indexItemOwn}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItemOwn < this.options.length - 1) {
      	this.indexItemOwn++;
        this.$refs[`own-${this.indexItemOwn}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`own-${this.indexItemOwn}-opt`][0].click();
      }
    },
    nextItemSecondLevel (key, event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.carrierIndex}-${this.indexItem}`][0].focus();
      } else if (event.keyCode == 38 && this.carrierIndex > 0) {
        this.carrierIndex--;
        const keyFind = Object.keys(this.filteredList)[this.carrierIndex];
      	this.indexItem = this.filteredList[keyFind].length - 1;
        this.$refs[`${this.carrierIndex}-${this.indexItem}`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.filteredList[key].length - 1) {
      	this.indexItem++;
        this.$refs[`${this.carrierIndex}-${this.indexItem}`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.carrierSize < (this.carrierIndex + 1)) {
        this.indexItem = 0;
        this.carrierIndex++;
        this.$refs[`${this.carrierIndex}-${this.indexItem}`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.carrierIndex}-${this.indexItem}`][0].click();
      }
    },
    nextItemFirstLevel (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.firstLevelIndexItem > 1) {
      	this.firstLevelIndexItem--;
        this.$refs[`opt-${this.firstLevelIndexItem}`].focus();
      } else if (event.keyCode == 40 && this.firstLevelIndexItem < 3) {
      	this.firstLevelIndexItem++;
        this.$refs[`opt-${this.firstLevelIndexItem}`].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`opt-${this.firstLevelIndexItem}`].click();
      }
    },
    changeValue(index, option) {
      this.$emit('change', option.value);
      this.$emit('input', option.value);
      this.search = '';
      this.closeSelect();
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
      this.currentLevelName = 'firstLevelPanel';
      this.currentLevel = 0;
      this.carrierSize = 0;
      this.carrierIndex = 0;
      this.indexItemOwn = 0;
      this.firstLevelIndexItem = 0;
      this.indexItem = 0;
    },
    openSecondLevel(val) {
      this.currentLevelName = val;
      this.currentLevel = -100;
      this.currentLevelName = val;
      const self = this;
      setTimeout(() => {
        if(self.currentLevelName === 'own') {
          self.$refs.searchField2.focus();
        } else {
          self.$refs.searchField1.focus();
        }
      }, 400);
    },
    openFirstLevel() {
      this.currentLevel = 0;
      const self = this;
      setTimeout(() => {
        self.currentLevelName = 'firstLevelPanel';
        self.currentLevelName = '';
      }, 350);
    },
  },
}
</script>
